"use client";

import { c as _c } from "react/compiler-runtime";
import type { Offer } from "@local/offer/src/types";
import { useState } from "react";
import { getT } from "@local/i18n/src/t";
import { getLanguageForMarket } from "@local/i18n/src/languages";
import { home } from "@local/i18n/src/catalogs/home";
import { Button } from "../../uiv7/Button";
import { ContentBlock } from "../../ui/ContentBlock";
import { BestSellersBigBlock } from "./BestSellersBigBlock";
import { BestSellersMappedBlocks } from "./BestSellersMappedBlocks";
import { ArrowTitle } from "../../ui/ArrowTitle";
export interface BestSellersProps {
  content: Offer.BestSellers;
  market?: string;
}
export const BestSellers = t0 => {
  const $ = _c(18);
  const {
    content: t1,
    market
  } = t0;
  const {
    headline,
    mobileImage,
    products
  } = t1;
  const [isVisible, setIsVisible] = useState(false);
  let T0;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== headline || $[1] !== isVisible || $[2] !== market || $[3] !== mobileImage || $[4] !== products) {
    const t = getT(getLanguageForMarket(market), {
      home
    });
    const currentHeadline = headline ?? t("home.bestSellersHeadline");
    T0 = ContentBlock;
    t5 = "mt-6 flex max-w-6xl! flex-col justify-center py-10 lg:py-6";
    t2 = "relative mx-6 xl:mx-0";
    t3 = <ArrowTitle headline={currentHeadline} />;
    t4 = products ? <><div className="relative hidden grid-cols-1 gap-8 pt-6 pb-8 md:grid md:grid-cols-2"><div><BestSellersBigBlock product={products?.[0]} mobileImage={mobileImage} market={market} /></div><div><BestSellersMappedBlocks skipFirst={true} vertical={true} isVisible={isVisible} products={products} market={market} /></div></div><div className={`relative pt-6 md:hidden ${isVisible ? "pb-8" : "pb-16"}`}><BestSellersMappedBlocks isVisible={isVisible} products={products} market={market} />{!isVisible && <div className="absolute -mt-6 w-full"><Button type="button" onClick={() => setIsVisible(!isVisible)} className="bottom-1 mx-auto w-[91%] max-w-full min-w-0 text-lg font-medium uppercase md:w-full md:max-w-[340px]">{t("home.viewMore")}</Button></div>}</div></> : null;
    $[0] = headline;
    $[1] = isVisible;
    $[2] = market;
    $[3] = mobileImage;
    $[4] = products;
    $[5] = T0;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    T0 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
    t6 = <div className={t2}>{t3}{t4}</div>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== T0 || $[15] !== t5 || $[16] !== t6) {
    t7 = <T0 className={t5}>{t6}</T0>;
    $[14] = T0;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};
export { BestSellersShimmer } from "./Shimmer";